import { useUserStore } from '~/store/user';
import { redirectToSignIn, requireAuth, getRedirectUrl, storeRedirectUrl, authState } from '~/util/auth';

export const useAuth = () => {
  const userStore = useUserStore();
  const router = useRouter();

  // Check if user is authenticated
  const isAuthenticated = computed(() => userStore.isLoggedIn);

  // Get current user info
  const user = computed(() => userStore.user);
  const userEmail = computed(() => userStore.email);
  const userId = computed(() => userStore.uid);

  // Sign out user
  const signOut = async () => {
    try {
      await userStore.signOut();
      console.log("User signed out successfully");
      router.replace('/');
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  // Require authentication for a page
  const requireAuthentication = () => {
    return requireAuth();
  };

  // Redirect to sign-in with current page as redirect target
  const signIn = () => {
    redirectToSignIn();
  };

  // Get the redirect URL after authentication
  const getRedirectAfterAuth = () => {
    return getRedirectUrl();
  };

  // Check if user is loading or authenticating
  const isLoading = computed(() => authState.isLoading || authState.isAuthenticating);
  const hasError = computed(() => !!authState.error);
  const errorMessage = computed(() => authState.error);

  return {
    // State
    isAuthenticated,
    user,
    userEmail,
    userId,
    isLoading,
    hasError,
    errorMessage,
    
    // Actions
    signOut,
    signIn,
    requireAuthentication,
    getRedirectAfterAuth,
  };
};
